import { z } from 'zod'

export const DOWNLOAD_LINK_NAME_MAX_LENGTH = 80

const DOWNLOAD_LINK_CODE_PATTERN = /^[a-z0-9]{1,16}$/

/** Whether a `?l=` value can be a download link code. */
export function isDownloadLinkCode(value: string): boolean {
  return DOWNLOAD_LINK_CODE_PATTERN.test(value)
}

export const downloadLinkPlatformValues = ['ios', 'android', 'other'] as const
export type DownloadLinkPlatform = (typeof downloadLinkPlatformValues)[number]

export const downloadLinkCodeSchema = z.string().regex(DOWNLOAD_LINK_CODE_PATTERN)

export const createDownloadLinkSchema = z.object({
  name: z.string().trim().min(1).max(DOWNLOAD_LINK_NAME_MAX_LENGTH),
})

export const trackDownloadLinkClickSchema = z.object({
  platform: z.enum(downloadLinkPlatformValues),
})

const count = () => z.number().int().nonnegative()

/**
 * A download link with its tap counts. `visitors` counts distinct devices per day;
 * `last7Days` holds taps per Europe/Vienna day, oldest first, ending today.
 */
export const downloadLinkSchema = z.object({
  id: z.string().uuid(),
  code: downloadLinkCodeSchema,
  name: z.string(),
  url: z.string().url(),
  createdAt: z.string().datetime(),
  archivedAt: z.string().datetime().nullable(),
  clicks: count(),
  visitors: count(),
  ios: count(),
  android: count(),
  other: count(),
  last7Days: z.array(count()).length(7),
})

export const downloadLinkListResponseSchema = z.array(downloadLinkSchema)

export type CreateDownloadLink = z.infer<typeof createDownloadLinkSchema>
export type TrackDownloadLinkClick = z.infer<typeof trackDownloadLinkClickSchema>
export type DownloadLink = z.infer<typeof downloadLinkSchema>
